import React from 'react';

import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { SummaryCardHelp } from '~/modules/common/components';
import { useMeContext } from '~/modules/me/useMeContext';

const ResourceHoursHelp = ({ type }) => {
  const intl = useIntl();
  const { isPolarisResourcingEnabled } = useMeContext();

  const toolTipContent = content(intl, type, isPolarisResourcingEnabled);

  return <SummaryCardHelp content={toolTipContent} />;
};

const content = (intl, type, isPolarisResourcingEnabled) => {
  const hoursAlertId = `resourceHoursHelp.${type}HoursAlert`;
  const allocatedAlertId = `resourceHoursHelp.${type}AllocatedAlert`;

  return [
    {
      title: intl.formatMessage({ id: 'resourceHoursHelp.hours' }),
      message: intl.formatMessage({ id: hoursAlertId })
    },
    ...(isPolarisResourcingEnabled
      ? [
          {
            title: intl.formatMessage({ id: 'resourceHoursHelp.allocated' }),
            message: intl.formatMessage({ id: allocatedAlertId })
          }
        ]
      : [])
  ];
};

ResourceHoursHelp.propTypes = {
  type: PropTypes.string.isRequired
};

export default ResourceHoursHelp;
